import { render, staticRenderFns } from "./ConservedPolices.vue?vue&type=template&id=29ca33bb&scoped=true&"
import script from "./ConservedPolices.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConservedPolices.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca33bb",
  null
  
)

export default component.exports